export const pingPageView = () => {
  // This is all specific to our page on Google analytics.
  const trackingId = 'UA-177162487-1'
  const fullPath = window.location.pathname + window.location.search
  // @ts-ignore
  window.gtag('config', trackingId, { page_path: fullPath })
}
